var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "_ovfl" }, [
    _c(
      "div",
      { staticClass: "_ovfs" },
      [
        _c(
          "transition",
          { attrs: { name: "_ovfto", duration: 500 } },
          [
            _vm.arrows
              ? _c(
                  "ib-button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.moreBack,
                        expression: "moreBack",
                      },
                    ],
                    staticClass: "link mirror-rtl text-start",
                    class: _vm.$rtl ? "_ovfbr" : "_ovfbl",
                    attrs: { "aria-hidden": "true" },
                    on: { click: _vm.back },
                  },
                  [
                    _c("svg", { attrs: { viewBox: "0 0 24 24" } }, [
                      _c("path", {
                        attrs: {
                          d: "M9.85 12.04l8.28 8.28a2.27 2.27 0 010 3.06 2.27 2.27 0 01-3.06 0l-9.75-9.87a2.27 2.27 0 010-3.06L15.07.7a2.2 2.2 0 011.47-.68 1.83 1.83 0 011.48.68 2.27 2.27 0 010 3.06z",
                        },
                      }),
                    ]),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "size",
            rawName: "v-size.width",
            value: _vm.refresh,
            expression: "refresh",
            modifiers: { width: true },
          },
        ],
        ref: "main",
        staticClass: "_ovfm",
        class: _vm.mainClass,
        on: { scroll: _vm.refresh },
      },
      [_vm._t("default")],
      2
    ),
    _c(
      "div",
      { staticClass: "_ovfe" },
      [
        _c(
          "transition",
          { attrs: { name: "_ovfto", duration: 500 } },
          [
            _vm.arrows
              ? _c(
                  "ib-button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.moreNext,
                        expression: "moreNext",
                      },
                    ],
                    staticClass: "link mirror-rtl text-end",
                    class: _vm.$rtl ? "_ovfbl" : "_ovfbr",
                    attrs: { "aria-hidden": "true" },
                    on: { click: _vm.next },
                  },
                  [
                    _c("svg", { attrs: { viewBox: "0 0 24 24" } }, [
                      _c("path", {
                        attrs: {
                          d: "M14.15 12.04l-8.28 8.28a2.27 2.27 0 000 3.06 2.27 2.27 0 003.06 0l9.75-9.87a2.27 2.27 0 000-3.06L8.93.7A2.2 2.2 0 007.46.02 1.83 1.83 0 005.98.7a2.27 2.27 0 000 3.06z",
                        },
                      }),
                    ]),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }